module.exports = global["jQuery"] = require("-!/builds/lobaro/iot-dashboard/node_modules/jquery/dist/jquery.min.js");


/*****************
 ** WEBPACK FOOTER
 ** ./~/expose-loader?jQuery!./~/jquery/dist/jquery.min.js
 ** module id = 16
 ** module chunks = 0 4
 **/